import { httpClient } from "@/shared/infrastructure/http/http-client";
import type { TermsRepositoryPort } from "../../application/ports/terms.repository.port";
import type {
  AcceptTermsResult,
  PendingTerm,
  TermsAcceptance,
  TermsAcceptanceItem,
  TermsDocument,
} from "../../domain/entities";

export const termsHttpRepository: TermsRepositoryPort = {
  getCurrent(): Promise<TermsDocument[]> {
    return httpClient<TermsDocument[]>("/terms/current", { skipAuth: true });
  },

  async getPending(): Promise<PendingTerm[]> {
    const res = await httpClient<{ pending: PendingTerm[] }>("/terms/pending");
    return res?.pending ?? [];
  },

  accept(items: TermsAcceptanceItem[]): Promise<AcceptTermsResult> {
    return httpClient<AcceptTermsResult>("/terms/accept", {
      method: "POST",
      body: { items },
    });
  },

  getHistory(): Promise<TermsAcceptance[]> {
    return httpClient<TermsAcceptance[]>("/terms/history");
  },
};
